import { types } from 'mobx-state-tree';

export const LoginData = types.model('LoginData', {
    payload: '',
    signature: '',
    redirect: types.maybeNull(types.string),
});

export default LoginData;
